import { Link } from 'react-router-dom';
import { ArrowRight, Buildings, FlagBanner, Handshake } from '@phosphor-icons/react';

const CARDS = [
  { icon: Handshake, title: 'Outsourcing Company for Land Survey CAD Drafting', path: '/outsourcing-company-land-survey-cad-drafting', desc: 'A dedicated, white-label drafting team that works in your template and under your seal.' },
  { icon: FlagBanner, title: 'CAD Drafting Service Provider in USA for Land Surveying', path: '/cad-drafting-service-provider-usa-land-surveying', desc: 'ALTA/NSPS, boundary, topographic and as-built drafting for firms in all 50 states.' },
  { icon: Buildings, title: 'Land Survey CAD Drafting Services', path: '/services/land-surveying', desc: 'Every survey type drafted in Civil 3D, Carlson, AutoCAD or MicroStation.' },
];

export const HomeSearchIntents = () => (
  <section className="py-16 bg-white border-b border-zinc-200" data-testid="home-search-intents">
    <div className="container-custom">
      <h2 className="heading-2 mb-4 max-w-3xl">Outsourced Land Survey CAD Drafting Services in the USA</h2>
      <p className="body-text mb-10 max-w-3xl">SurveysMaps is a land survey CAD drafting service provider for US surveying firms. Send your field data and get finished, seal-ready drawings back in 24–48 hours, drafted to your standards by a team that works only on survey drafting.</p>
      <div className="grid md:grid-cols-3 gap-6">
        {CARDS.map(({ icon: Icon, title, path, desc }) => (
          <Link key={path} to={path} className="group border border-zinc-200 rounded-xl p-6 hover:border-[#3B82F6] hover:-translate-y-1 transition-[transform,border-color] duration-300" data-testid={`home-intent-${path.split('/').pop()}`}>
            <Icon size={28} className="text-[#3B82F6] mb-4" />
            <h3 className="text-lg font-bold text-zinc-900 mb-2 group-hover:text-[#3B82F6]" style={{ fontFamily: 'Outfit' }}>{title}</h3>
            <p className="text-sm text-zinc-600 mb-4">{desc}</p>
            <span className="text-sm font-semibold text-[#3B82F6] inline-flex items-center gap-1">Learn more <ArrowRight size={14} /></span>
          </Link>
        ))}
      </div>
    </div>
  </section>
);
